import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'

import SalesUsersApi from 'api/admins/sales-users-api'

import { TitlePage, RedirectButton } from 'components/atoms'
import { ALERT_TYPES } from 'constants/alert-constants'
import SalesUsersForm from 'domains/sales/users/forms/user-form/sales-users-form'

const LIST_PATH = '/app/sales/users'

const SalesUsersCreatePage = ({ pageUtils }) => {
  const history = useHistory()
  const [submitting, setSubmitting] = useState(false)

  const onSubmit = async (payload) => {
    setSubmitting(true)
    try {
      const response = await SalesUsersApi.create({ payload })
      const user = response?.data?.user

      pageUtils?.setAlertMsg?.('User berhasil dibuat.', ALERT_TYPES.SUCCESS)

      if (user?.id) {
        history.push(`${LIST_PATH}/${user.id}`)
      } else {
        history.push(LIST_PATH)
      }

      return user
    } catch (e) {
      pageUtils?.setApiErrorMsg?.(e?.response?.data)
      pageUtils?.setAlertMsg?.(e?.response?.data?.message || e?.message || 'Create user gagal.', ALERT_TYPES.ERROR)
      throw e
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <TitlePage
        mainTitle="Create User"
      />

      <Container fluid>
        <Row>
          <Col lg="12" className="text-right mb-3">
            <RedirectButton path={LIST_PATH} label="Back" />
          </Col>

          <Col lg="12">
            <Card>
              <CardBody>
                <SalesUsersForm
                  mode="create"
                  user={null}
                  submitting={submitting}
                  onSubmit={onSubmit}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

SalesUsersCreatePage.propTypes = {
  pageUtils: PropTypes.object,
}

export default SalesUsersCreatePage
